import { useFormContext, Controller } from 'react-hook-form';
import { TextField, MenuItem } from '@mui/material';

type SelectOption = {
  label: string;
  value: string | number;
};

type SelectBoxProps = {
  name: string;
  options: SelectOption[];
} & Omit<React.ComponentProps<typeof TextField>, 'name' | 'select'>;

const SelectBox = ({ name, options, helperText, ...other }: SelectBoxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          error={!!error}
          helperText={error?.message || helperText}
          {...other}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

export default SelectBox;
